var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15C16 15.552 15.552 16 15 16H5C4.448 16 4 15.552 4 15C4 14.448 4.448 14 5 14H15C15.552 14 16 14.448 16 15ZM5 10H15C15.552 10 16 10.448 16 11C16 11.552 15.552 12 15 12H5C4.448 12 4 11.552 4 11C4 10.448 4.448 10 5 10ZM18 17C18 17.552 17.552 18 17 18H3C2.448 18 2 17.552 2 17V3C2 2.448 2.448 2 3 2H12V6C12 7.104 12.895 8 14 8H18V17ZM19.707 5.707L14.293 0.292999C14.105 0.104999 13.851 0 13.586 0H2C0.895 0 0 0.895 0 2V18C0 19.104 0.895 20 2 20H18C19.105 20 20 19.104 20 18V6.414C20 6.149 19.895 5.895 19.707 5.707Z",
    fill: "#3B414D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.01bdef126892b0e780d90525ad2ddfec.svg";
export { ForwardRef as ReactComponent };